import routes from 'utils/routeTranslator';

export const pathToL3CityPage = (l3Slug: string, citySlug: string): string => {
  return routes.get('front::provider.register.l3.city', {
    slug: l3Slug,
    city: citySlug,
  });
};
